import React from "react";
import { motion } from "motion/react";
import { Users, CheckCircle, Clock } from "lucide-react";

const AdminStats = ({ totalAdmins, activeAdmins, inactiveAdmins }) => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="grid grid-cols-1 gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-3"
    >
      <motion.div
        variants={itemVariants}
        className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm"
      >
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Admins</p>
            <p className="text-3xl font-bold text-gray-900">{totalAdmins}</p>
          </div>
          <div className="p-3 bg-blue-100 rounded-xl">
            <Users className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm"
      >
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium text-gray-600">Active Admins</p>
            <p className="text-3xl font-bold text-red-600">{activeAdmins}</p>
          </div>
          <div className="p-3 bg-red-100 rounded-xl">
            <CheckCircle className="w-6 h-6 text-red-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm"
      >
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium text-gray-600">Inactive Admins</p>
            <p className="text-3xl font-bold text-orange-600">
              {inactiveAdmins}
            </p>
          </div>
          <div className="p-3 bg-orange-100 rounded-xl">
            <Clock className="w-6 h-6 text-orange-600" />
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default AdminStats;
